/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Plain_Text_Import_Docx_Error_ToastInputs */

const en_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error processing DocX: ${i?.error}`)
};

const fr_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erreur lors du traitement du DocX : ${i?.error}`)
};

const de_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fehler bei der Verarbeitung von DocX: ${i?.error}`)
};

const it_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Errore durante l'elaborazione di DocX: ${i?.error}`)
};

const ru_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ошибка обработки DocX: ${i?.error}`)
};

const es_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error al procesar DocX: ${i?.error}`)
};

const zh_cn2_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`处理 DocX 时出错：${i?.error}`)
};

const ja_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`DocX の処理中にエラーが発生しました: ${i?.error}`)
};

const hi_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`DocX को संसाधित करने में त्रुटि: ${i?.error}`)
};

const pt_pt2_plain_text_import_docx_error_toast = /** @type {(inputs: Plain_Text_Import_Docx_Error_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Erro ao processar o DocX: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Error processing DocX: {error}" |
*
* @param {Plain_Text_Import_Docx_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_docx_error_toast = /** @type {((inputs: Plain_Text_Import_Docx_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Docx_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_docx_error_toast(inputs)
	if (locale === "de") return de_plain_text_import_docx_error_toast(inputs)
	if (locale === "it") return it_plain_text_import_docx_error_toast(inputs)
	if (locale === "ru") return ru_plain_text_import_docx_error_toast(inputs)
	if (locale === "es") return es_plain_text_import_docx_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_docx_error_toast(inputs)
	if (locale === "ja") return ja_plain_text_import_docx_error_toast(inputs)
	if (locale === "hi") return hi_plain_text_import_docx_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_docx_error_toast(inputs)
	return en_plain_text_import_docx_error_toast(inputs)
});